import HiddenInputText from './gameobjects/dom/hiddeninputtext/HiddenInputText.js';
export default HiddenInputText;